import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DRAWER_KEY, MODAL_KEYS, PLAN_STATUS_KEY } from 'app-constants'
import { fetchObjections } from 'slices/contract'
import { fetchMessages } from 'slices/messages'
import { fetchMassiveWarningByUnityAndContractId } from 'slices/massive'
import {
  fetchContactUpdate,
  setDashboardModalOpen,
  setDashboardModals,
  setHasLoadedModalInfo,
  setModal,
} from 'slices/modal'
import { setData, setDrawer } from 'slices/drawer'

export function useDashboardMessages(selectedContract) {
  const { id, unity, contractStatus } = selectedContract
  const messages = useSelector(state => state.messages)
  const massive = useSelector(state => state.massive)
  const { dashboardModals } = useSelector(state => state.modal)
  const { key: currentDrawerKey } = useSelector(({ drawer }) => drawer)
  const { objection } = useSelector(({ contract }) => ({
    objection: contract.objection,
  }))
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchContactUpdate(id))
    dispatch(fetchObjections(id))
    dispatch(fetchMessages(id))
  }, [dispatch, id])

  useEffect(() => {
    dispatch(fetchMassiveWarningByUnityAndContractId({ unity, idContract: id }))
  }, [unity, id, dispatch])

  useEffect(() => {
    function handleMessageFullScreen() {
      const messageWithFullScreen = messages.contentUnread.find(msg => msg.mandatoryFullScreen)
      if (messageWithFullScreen) {
        dispatch(setDrawer(DRAWER_KEY.MESSAGES))
        dispatch(setData(messageWithFullScreen))
      }
    }

    const isLoadingInfo =
      messages.isLoading || massive.isLoading || dashboardModals.isLoadingContactUpdate

    if (!isLoadingInfo && !dashboardModals.hasLoadedModalInfo) {
      handleMessageFullScreen()
      const hasUnreadMandatoryMessage = messages.contentUnread.some(msg => msg.mandatory)
      const hasUnityMassive = massive.virtualSupportMassive?.message
      const isEnabledContract = contractStatus === PLAN_STATUS_KEY.ST_CONT_HABILITADO
      const shouldOpenMessageModal =
        hasUnreadMandatoryMessage || (hasUnityMassive && isEnabledContract)

      dispatch(
        setDashboardModals({
          openContactUpdate: dashboardModals.openContactUpdate,
          openObjection: !!objection,
          openMessages: shouldOpenMessageModal,
        })
      )
      dispatch(setHasLoadedModalInfo(true))
    }
  }, [
    dispatch,
    messages.contentUnread,
    messages.isLoading,
    massive.isLoading,
    massive.virtualSupportMassive,
    contractStatus,
    dashboardModals.isLoadingContactUpdate,
    dashboardModals.openContactUpdate,
    dashboardModals.hasLoadedModalInfo,
    objection,
  ])

  useEffect(() => {
    function openModal(modalKey, newState) {
      dispatch(setDashboardModalOpen(true))
      dispatch(setDashboardModals({ ...dashboardModals, ...newState }))
      dispatch(setModal({ key: modalKey }))
    }
    const shouldOpenModal =
      dashboardModals.hasLoadedModalInfo && !dashboardModals.isOpen && currentDrawerKey === ''

    if (shouldOpenModal) {
      if (dashboardModals.openMessages) {
        openModal(MODAL_KEYS.MESSAGES, { openMessages: false })
      } else if (dashboardModals.openContactUpdate) {
        openModal(MODAL_KEYS.CONTACT_UPDATE, { openContactUpdate: false })
      } else if (dashboardModals.openObjection) {
        openModal(MODAL_KEYS.OBJECTIONS, { openObjection: false })
      }
    }
  }, [
    currentDrawerKey,
    dashboardModals.isOpen,
    dashboardModals.openObjection,
    dashboardModals.openContactUpdate,
    dashboardModals.openMessages,
    dashboardModals.hasLoadedModalInfo,
    dashboardModals,
    dispatch,
  ])
}
